import React, { Component } from 'react';
import { Link } from 'react-router-dom';

/**
 * This Classcontains the design  of the card displayed in list of articles in a sections
 */
class HelpList extends Component {

    render() {
        return (
            <Link className="help-support-card-container" to={"/articledetails/" + this.props.displayData.id}>
                <div className="help-support-card" style={{ width: "calc(100% - 15px)" }}>
                    <div className="help-support-card-title" style={{ marginBottom: "12px" }}>
                        {this.props.displayData.title}
                    </div>
                    {/* <div className="help-support-card-desc">
                        {this.props.displayData.description}
                    </div> */}
                </div>
                {/* <div className="help-support-card-icon">
                    <img src={right} alt="" />
                </div> */}
            </Link>
        )
    }
}

export default HelpList;


// WEBPACK FOOTER //
// ./src/components/Articles/HelpList.js